const deployment = {
  bindings: {
    workspace: '<',
    mode: '<',
    onSubmit: '&',
    onCancel: '&'
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/deployment/deployment.html',
};

angular
  .module('pis-tool.module')
  .component('deployment', deployment);
